import React, { useState } from "react";

import { Example, Compare } from "../../example";
import { AcceptInput } from "./component";

export default function HighlightErrorDemo() {
  return (
    <Example
      title="Highlight errors"
      desc={
        <>
          <p>
            Highlight errors right in the place. No more messages like "Username
            should contain only...". Show what's wrong!
          </p>
          <p>⚠️ This field accepts only alphanumeric characters.</p>
        </>
      }
      filepath="/src/examples/HighlightError/component.js"
      demo={Demo}
    />
  );
}

function Demo() {
  const [value, setValue] = useState("user$1%\ud83d\ude05");

  const isOk = /^[A-Za-z0-9]*$/.test(value);

  return (
    <Compare>
      <Compare.Group title={<code>{"<input>"}</code>}>
        <label>
          <span className="exampleBlock-label">Username</span>
          <input
            className={isOk ? "regularInput" : "regularInput --incorrect"}
            value={value}
            onChange={e => {
              setValue(e.target.value);
            }}
          />
        </label>
      </Compare.Group>
      <Compare.Group title={<code>{"<MightyInput>"}</code>}>
        <label>
          <span className="exampleBlock-label">Username</span>
          <AcceptInput
            className={isOk ? "myInput" : "myInput --incorrect"}
            value={value}
            accept={/[A-Za-z0-9]/}
            onUpdate={next => setValue(next)}
          />
        </label>
      </Compare.Group>
    </Compare>
  );
}
